module.exports = __webpack_public_path__ + "img/2025special_05.58f954eb.jpg";